module.exports = __webpack_public_path__ + "img/fuelpump.83c0dc40.svg";